<template>
	<component :is="icon" :class="class" />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
	icon: {
		type: String,
		required: true,
	},
	class: {
		type: String,
	},
})

const icon = defineAsyncComponent(() => import(`../../svg/${props.icon}.svg`))
</script>
